<template>
  <div class="wrapper-page">
    <modal ref='documentTypeUserEditInfo'>
      <template #header>
        <h5 class="modal-title mt-0">{{$t('document_types.edit_info')}}
          <span>{{$t('document_types.note')}}</span>
        </h5>
      </template>

      <template #body>
        <form @submit.prevent="">
          <div class="modal-body">
            <div class="form-group">
              <label class="col-form-label">
                {{$t('document_types.change')}} <strong>{{ userDocumentTypeTitle }}</strong> {{$t('document_types.change_to')}}
              </label>

              <input
                      type="text"
                      name="default[title]"
                      class="form-control"
                      required="required"
                      :placeholder= 'userDocumentTypeTitle'
                      v-model='userDocumentType.title' />
            </div>
            <div class="form-group">
              <label class="col-form-label">
                {{$t('document_types.change')}} <strong>{{ userDocumentTypeName }}</strong> {{$t('document_types.change_to')}}
              </label>

              <input type="text"
                     name="default[name]"
                     class="form-control"
                     :placeholder= 'userDocumentTypeName'
                     v-model='userDocumentType.name' />
            </div>
          </div>

          <div class="modal-footer">
            <button
                    type="reset"
                    data-dismiss="modal"
                    @click.prevent="resetValues"
                    class="btn btn-neutral">{{ $t('document_types.cancel') }}</button>
            <button
                    type="submit"
                    name="commit"
                    class="btn btn-primary"
                    @click.prevent="updateUserOptions">{{$t('products.save')}}</button>
          </div>
        </form>
      </template>
    </modal>
    <modal ref='documentForm'>
      <template #header>
        <h5 v-if='Object.keys(selectedDocument).length === 0' class="modal-title mt-0">{{ $t('document_types.index.add') }} {{ userDocumentTypeTitle }}</h5>
        <h5 v-else class="modal-title mt-0">{{ $t('document_types.index.edit') }} {{ userDocumentTypeTitle }}</h5>
      </template>

      <template #body>
        <form @submit.prevent="createOrUpdateDocument($event)">
          <div class="modal-body">
            <div class="form-group">
              <label class="col-form-label">
                {{ userDocumentTypeName }}
              </label>

              <input type="text" name="document_type[name]" class="form-control" required="required" :value='selectedDocument.name' />
            </div>
          </div>

          <div class="modal-footer">
            <input type="submit" name="commit" :value="$t('document_types.index.save')" class="btn btn-primary float-right">
          </div>
        </form>
      </template>
    </modal>

    <import ref='import' />

    <div class="container-fluid">
      <h1 class="page-title">
        {{ userDocumentTypeTitle }}
        <a href="#" class="edit" @click.prevent='openModal($refs.documentTypeUserEditInfo)'>
          {{ $t('document_types.edit') }}
        </a>
      </h1>

      <div class='clearfix'></div>


      <a href="#" class="btn btn-primary float-right" @click.prevent="openModal($refs.documentForm)">
        {{ $t('document_types.index.add_new') }}
      </a>

      <a href="#" @click.prevent="$refs.import.open" class="btn btn-outline-primary float-right m-r-10">
        {{ $t('document_types.index.import') }}
      </a>

      <div class="nav-tabs-wrapper">
        <ul role="tablist" class="nav nav-tabs">
          <li class="nav-item">
            <router-link :to="{ name: 'document_types' }" :class="['nav-link', 'show', { active: activeTab == 'active' }]">
              {{ userDocumentTypeTitle }} ({{activeDocumentTypes}})
            </router-link>
          </li>

          <li class="nav-item">
            <router-link :to="{ name: 'archived_document_types' }" :class="['nav-link', 'show', { active: activeTab == 'archived' }]">
              {{ $t('document_types.index.archived') }} {{ userDocumentTypeTitle }} ({{archivedDocumentTypes}})
            </router-link>
          </li>
        </ul>
      </div>

      <div class="tab-content">
        <div class="btn-group float-right show-hide-columns" role="group" v-click-outside="closeDropdown">
          <button class="btn btn-neutral dropdown-toggle" v-on:click="openDropdown = !openDropdown">
            {{$t('contacts.show_hide_columns')}}
          </button>

          <ul class="dropdown-menu" v-if="openDropdown">
            <li class="dropdown-item" @click="toggleColumns('name')">
              <input type="checkbox" :checked="showName" />
              {{ userDocumentTypeName }}
            </li>
            <li class="dropdown-item" @click="toggleColumns('tags')">
              <input type="checkbox" :checked="showTags" />
              {{ $t('document_types.index.tags') }}
            </li>
            <li class="dropdown-item" @click="toggleColumns('actions')">
              <input type="checkbox" :checked="showActions" />
              {{ $t('document_types.index.actions') }}
            </li>
            <li>
              <button class="btn btn-primary float-right m-r-10" v-on:click="openDropdown = false">
                {{$t('contacts.edit_modal.save')}}
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div class="tab-content text-center">
        <div v-for='[id, active] in tabs' :id="id" :class="['tab-pane', {active: active}]" :key='id'>
          <div class="table_wrapper" v-if="documentTypes.length > 0 && !loading">
            <table class="table">
              <thead>
                <tr>
                  <th v-if="showName">{{ userDocumentTypeName }}</th>
                  <th v-if="showTags">{{ $t('document_types.index.tags') }}</th>
                  <th v-if="showActions">{{ $t('document_types.index.actions') }}</th>
                </tr>
              </thead>
              <tbody name="fade" is="transition-group">
                <tr class="clickable-row" v-for="documentType in documentTypes" :key='documentType.id'>
                  <td v-if="showName">
                    <router-link :to="{name: 'document_type', params: { id: documentType.id }}">
                      {{documentType.name}}
                    </router-link>
                  </td>

                  <td v-if="showTags" class="tag-dropdown-column">
                    <tag-manager resourceType='documentType' :resource="documentType" v-on:reload-list="fetchDocumentTypes()"></tag-manager>

                    <div class="existing-tags-wrapper" :class="tag.color" v-for="tag in documentType.tags" :key='tag.id'>
                      <div class="btn-group btn-group-toggle" data-toggle="buttons">
                        <label class="btn active">
                          <router-link :to="{name: 'tag', params: { id: tag.id }}">
                            {{tag.name}}
                          </router-link>
                        </label>

                        <label class="btn" @click.prevent="removeConnectedTag(tag, documentType.id)">
                          <i class="fa fa-remove"></i>
                        </label>
                      </div>
                    </div>
                  </td>

                  <td v-if="showActions" class="actions">
                    <ul>
                      <li :title="$t('document_types.index.edit_doc_type')">
                        <a href="#" @click.prevent="openModal($refs.documentForm, documentType)">
                          <i class="fas fa-edit"></i>
                        </a>
                      </li>
                      <li :title="documentType.archive ? $t('document_types.index.unarchive') : $t('document_types.index.archive')">
                        <a href="#" @click.prevent="toggleArchiveDocument(documentType)">
                          <i class="fas fa-archive"></i>
                        </a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="empty-list-wrapper" v-if="!documentTypes.length > 0 && !loading">
            <img src='../assets/empty_states/document-types.png'>
            <p>{{$t('document_types.index.no_archive_types')}}</p>
          </div>
          <loading v-if="loading" />
          <pagination :meta='meta' />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _modal from '../components/_modal'
  import _import from '../components/document_types/_import'
  import tag_manager from '../components/tags/_tags_manager'
  import _pagination from '../components/_pagination'
  import _loading from '../components/_loading'

  export default {
    components: {
      pagination: _pagination,
      'modal': _modal,
      'import': _import,
      'tag-manager': tag_manager,
      'loading': _loading
    },
    props: {
      activeTab: {
        type: String,
        default: 'active'
      }
    },
    created() {
      this.fetchDocumentTypes()
      this.store.sendMetrics({name: 'document_types', params: this.$route.params, path: this.$route.fullPath})
    },
    watch: {
      query() {
        this.fetchDocumentTypes()
      }
    },
    data() {
      return {
        loading: false,
        openDropdown: false,
        selectedDocument: {},
        userDocumentType: {},
        activeDocumentTypes: null,
        archivedDocumentTypes: null,
      }
    },
    computed: {
      params() {
        return Object.assign({ 'filters[archive]': this.$props.activeTab == 'archived' }, this.query)
      },
      documentTypes() {
        return this.state.documentTypes || []
      },
      tabs() {
        return [
          ['document_types', this.activeTab == 'active'],
          ['archived', this.activeTab == 'archived']
        ]
      },
      documentTypesColumns() {
        return new Set((this.userDefaults.document_types || []))
      },
      showName() {
        return this.documentTypesColumns.has('name')
      },
      showTags() {
        return this.documentTypesColumns.has('tags')
      },
      showActions() {
        return this.documentTypesColumns.has('actions')
      },
    },
    methods: {
      openModal(modal, document) {
        this.selectedDocument = Object.assign({}, document)
        modal.open()
      },
      removeConnectedTag(tag, documentTypeId) {
        this.store.removeConnectedTag(tag.id, { document_type_id: documentTypeId }).then(() => {
          this.fetchDocumentTypes()
        })
      },
      createOrUpdateDocument(event) {
        let promise = null

        if (this.selectedDocument.id) {
          promise = this.store.updateDocumentType(this.selectedDocument.id, new FormData(event.target))
          this.store.sendMetrics({name: 'update_doc_type', params: this.$route.params, path: this.$route.fullPath})

        } else {
          promise = this.store.createDocumentType(new FormData(event.target))
          this.store.sendMetrics({name: 'create_doc_type', params: this.$route.params, path: this.$route.fullPath})
        }

        promise.then(() => {
          this.fetchDocumentTypes()
          this.$refs.documentForm.close()
        })
      },
      toggleArchiveDocument(documentType) {
        this.store.updateDocumentType(documentType.id, { archive: !documentType.archive }).then(() => {
          this.store.sendMetrics({name: 'toggle_archive_doc_type', params: this.$route.params, path: this.$route.fullPath})
          this.fetchDocumentTypes()
        })
      },
      updateUserOptions() {
        let newDefaults = Object.assign({}, this.currentUser.defaults, { document_type_view: this.userDocumentType })
        this.store.updateUserProfile({ user: { defaults:  newDefaults} }).then(() => {
          this.store.getCurrentUser()
          this.$refs.documentTypeUserEditInfo.close()
        })
      },
      resetValues() {
        this.userDocumentType = Object.assign({}, this.currentUser.defaults.document_type_view)
      },
      closeDropdown() {
        this.openDropdown = false
      },
      toggleColumns(column) {
        const newDocumentTypesColumns = this.documentTypesColumns

        this.documentTypesColumns.has(column) ? newDocumentTypesColumns.delete(column) : newDocumentTypesColumns.add(column)

        const newDefaults = Object.assign({}, this.currentUser.defaults, { document_types: Array.from(newDocumentTypesColumns) })

        this.store.updateUserProfile({ user: { defaults: newDefaults } }).then(() => {
            this.store.getCurrentUser()
        })
      },
      fetchDocumentTypes() {
        this.loading = true
        this.selectedDocument = []

        this.listStore.getDocumentTypes({ 'filters[archive_eq]': false }).then((data) => {
          this.activeDocumentTypes = data.meta.total
        })

        this.listStore.getDocumentTypes({ 'filters[archive_eq]': true }).then((data) => {
          this.archivedDocumentTypes = data.meta.total
        })

        this.store.getDocumentTypes(this.params).then(() => {
          this.loading = false
          this.userDocumentType = Object.assign({}, this.currentUser.defaults.document_type_view)
        })
      },
    }
  }
</script>
<style lang="sass" scoped>
  .modal-header
    h5
      span
        display: block
        font-size: 14px
</style>
